import { mergeLeft, pick } from 'ramda'
import { Option, Select } from '../../atoms'
import { MonthSelect } from '../MonthSelect'
import { makeDates } from './helpers'
import { Container } from './styles'

export interface DateSelectProps {
  value?: {
    [key: string]: number
  }
  onChange: (value: { [key: string]: number }) => void
  dateKey?: string
  yearKey?: string
  monthKey?: string
  minDate?: Date
  maxDate?: Date
  shouldDisable?: boolean
}

export const DateSelect: React.FC<DateSelectProps> = ({
  value = {},
  onChange,
  dateKey = 'date',
  yearKey = 'year',
  monthKey = 'month',
  minDate = new Date('1900'),
  maxDate = new Date(),
  shouldDisable = true,
}) => {
  const dates = makeDates(value[monthKey], value[yearKey])

  const handleChange = (newValue: { [key: string]: number | undefined }) =>
    onChange(mergeLeft(newValue, value))

  return (
    <Container>
      <Select
        onSelect={(date?: string | number) =>
          date !== undefined && handleChange({ [dateKey]: Number(date) })
        }
        value={value[dateKey]}
      >
        {dates.map((item) => {
          const date = new Date(
            `${value[yearKey]}-${String(value[monthKey]).padStart(
              2,
              '0',
            )}-${String(item).padStart(2, '0')}`,
          )

          return (
            <Option
              key={item}
              disabled={shouldDisable && (date > maxDate || date < minDate)}
              value={item}
            >
              {item}
            </Option>
          )
        })}
      </Select>
      <MonthSelect
        maxDate={maxDate}
        minDate={minDate}
        monthKey={monthKey}
        onChange={handleChange}
        shouldDisable={shouldDisable}
        value={pick([monthKey, yearKey], value)}
        yearKey={yearKey}
      />
    </Container>
  )
}
